import { IFinancialSecurityGetDTO, IFinancialSecurityViewDTO } from "../../libs/coreapi-dto/dirs/financialSecurity";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";

export class FinancialSecurityDataProvider extends DictionaryDataProvider<IFinancialSecurityViewDTO, IFinancialSecurityGetDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<IFinancialSecurityViewDTO, IFinancialSecurityGetDTO>> {
        return this._coreApiService.financialSecurityRequest
    }
}